import { useState, type FormEvent } from 'react'
import { LogIn } from 'lucide-react'
import api, { simpanSesi, pesanGalat, type Sesi } from '../lib/api'
// Logo di-IMPOR, bukan ditulis sebagai "/logo-el.png".
//
// Berkas di public/ disalin Vite apa adanya beserta mode-nya; yang bermode 600
// tidak terbaca nginx dan tampil sebagai ikon rusak — ADA tapi tidak terbaca,
// jadi memeriksa "tersalin atau tidak" tidak menemukan apa pun.
//
// Yang di-impor dikeluarkan Vite sendiri ke /assets/ dengan mode 644 dan nama
// ber-hash. Jalur yang sama dengan JS aplikasinya — yang jelas terbaca, karena
// kalau tidak, halaman ini tidak akan muncul sama sekali.
import logoEl from '../assets/logo-el.png'

// Halaman masuk. Identitas karaoke BERDIRI SENDIRI (kr_user), bukan menumpang
// DivX — lihat migrate_user.sql untuk alasannya.
//
// Menerima email ATAU nomor HP: orang mengingat dirinya dengan cara berbeda,
// dan memaksa satu bentuk menghasilkan "sandi salah" pada orang yang sandinya
// sebenarnya benar.
//
// Halaman ini TIDAK menyebut DivX. Bagi yang memakainya, "akun karaoke
// terpisah dari DivX" bukan keterangan yang menolong — itu catatan arsitektur,
// dan yang membacanya justru bertanya-tanya apa hubungannya.
export default function Masuk({ selesai }: { selesai: (s: Sesi) => void }) {
  const [ident, setIdent] = useState('')
  const [sandi, setSandi] = useState('')
  const [galat, setGalat] = useState('')
  const [memuat, setMemuat] = useState(false)

  async function kirim(e: FormEvent) {
    e.preventDefault()
    setMemuat(true); setGalat('')
    try {
      const r = await api.post('/auth/login', { identitas: ident, password: sandi })
      simpanSesi(r.data as Sesi)
      selesai(r.data as Sesi)
    } catch (err) {
      setGalat(pesanGalat(err, 'Gagal masuk'))
    } finally {
      setMemuat(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <form onSubmit={kirim} className="w-full max-w-sm bg-bg-1 border border-border rounded-2xl p-7 space-y-4">
        <div className="flex items-center gap-2.5">
          {/* Logo dimuat sebagai <img>, bukan background-image CSS.
              background-image yang berkasnya 404 tidak menampilkan apa pun dan
              tidak melaporkan apa pun — kotaknya cuma kosong, dan tidak ada
              yang menduga sebabnya berkas hilang. onError membuat kegagalannya
              terlihat sebagai huruf "el", bukan sebagai ruang kosong. */}
          <img src={logoEl} alt="El Group" width={36} height={36}
            className="w-9 h-9 rounded-xl object-contain bg-gold/10 border border-gold/25 p-1"
            onError={(e) => {
              const el = e.currentTarget
              el.style.display = 'none'
              el.insertAdjacentHTML('afterend',
                '<div class="w-9 h-9 rounded-xl bg-gold/10 border border-gold/25 ' +
                'grid place-items-center text-gold text-[13px] font-semibold">el</div>')
            }} />
          <div>
            <div className="font-semibold leading-tight">Karaoke</div>
            <div className="text-[11px] text-text-3">Katalog pusat El Group</div>
          </div>
        </div>

        <div className="space-y-2.5">
          <input required value={ident} onChange={(e) => setIdent(e.target.value)}
            placeholder="Email atau nomor HP" autoComplete="username" className="w-full" />
          <input type="password" required value={sandi} onChange={(e) => setSandi(e.target.value)}
            placeholder="Kata sandi" autoComplete="current-password" className="w-full" />
        </div>

        {galat && (
          <div className="text-[12px] text-red-400 bg-red-500/10 border border-red-500/25 rounded-lg px-3 py-2">
            {galat}
          </div>
        )}

        <button type="submit" disabled={memuat}
          className="w-full flex items-center justify-center gap-2 bg-gold/15 hover:bg-gold/25 border border-gold/30
                     text-gold rounded-lg py-2.5 text-[13px] font-medium transition-colors disabled:opacity-50">
          <LogIn size={15} /> {memuat ? 'Memeriksa…' : 'Masuk'}
        </button>

        <p className="text-[11px] text-text-3 leading-relaxed">
          Belum punya akun? Minta dibuatkan oleh rekan yang berizin kelola pengguna.
        </p>
      </form>
    </div>
  )
}
